/* 中文词典：game 命名空间。见 src/i18n/README.md。 */

import type { TextSpec } from '../text';

const game = {
  'game.cardCount': [ { type: 'param', name: 'n' }, ' 张' ],
  'game.tracker.title': [ '记牌器' ],
  'game.tracker.titlePick': [ '记牌器 · 点击表头从弃牌堆选取' ],
  'game.tracker.row.status': [ '状态' ],
  'game.tracker.row.located': [ '牌堆-已追踪' ],
  'game.tracker.row.region': [ '牌堆-半追踪（推测）' ],
  'game.tracker.row.untracked': [ '牌堆-未追踪（推测）' ],
  'game.tracker.row.otherHand': [ { type: 'param', name: 'name' }, '手牌（推测）' ],
  'game.tracker.cellExact': [ '精确值 ', { type: 'param', name: 'value' } ],
  'game.tracker.hintHover': [ '悬停表头的牌或表格里的数字，查看详细说明' ],
  'game.tracker.hintTouch': [ '点击表头的牌或表格里的数字，查看详细说明' ],
  'game.steal.hint': [ '从对手手中抽取一张牌' ],
  'game.settlement.noWinner': [ '无人胜出' ],
  'game.settlement.winner': [ { type: 'param', name: 'name' }, ' 获胜' ],
  'game.settlement.alive': [ '存活' ],
  'game.settlement.eliminated': [ '出局' ],
  'game.settlement.row': [ { type: 'param', name: 'status' }, '   ', { type: 'param', name: 'name' }, '   手牌 ', { type: 'param', name: 'n' } ],
  'game.chooseName': [ '选择牌名' ],
  'game.give.unnamed': [ '对手索要一张牌' ],
  'game.give.named': [ '对手索要[', { type: 'param', name: 'name' }, ']' ],
  'game.menu.title': [ '菜单' ],
  'game.menu.saveAndExit': [ '保存并退出' ],
  'game.menu.leave': [ '退出对局' ],
  'game.menu.sync': [ '刷新同步' ],
  'game.menu.syncing': [ '同步中…' ],
  'game.menu.synced': [ '已同步' ],
  'game.menu.syncFailed': [ '同步失败' ],
  'game.online.syncFailed': [ '[s3] 手动同步失败：' ],
  'game.online.stalePick': [ '[s3] 抽牌点击落空：当前没有抽牌抉择' ],
  'game.online.sendFailed': [ '[s3] 动作发送失败：' ],
  'game.online.sendFailedReason': [ '发送失败（网络异常）' ],
  'game.online.rejected': [ '[s3] 房主拒绝了这个动作，已回退：' ],
  'game.online.reasonPrefix': [ '原因：' ],
  'game.online.protocolError': [ '[s3] 对局协议错误：' ],
} as const;

// 静态检查（写在对象字面量之外，避免 TextKey 循环推断）
game satisfies Record<string, TextSpec>;
export default game;
